

































































































































































































































import ActionBar from '@/components/action-bar/action-bar.vue';
import PageLoader from '@/components/page-loader/page-loader.vue';
import { CONFIG } from '@/config';
import { normalize, stringService, dateService, httpService } from '@/services';
import * as _ from 'lodash';
import * as moment from 'moment';
import { debounceTime, distinctUntilChanged, pluck, startWith } from 'rxjs/operators';
import { Component, Vue } from 'vue-property-decorator';
import { Http } from '@/decorators';
import { DAP_ROUTES } from '@/modules/dap/router';
import { Getter } from 'vuex-class';
import { AUTH_GET_TOKEN, AUTH_GET_USERNAME } from '@/store/modules/authentication/types';
import { Size } from '@/enums';
import { GET_LOADING } from '@/store/types';
import { IProject } from '@/modules/dap/interfaces';
import ProjectLoader from '@/modules/dap/components/project-loader/project-loader.vue';
import { AxiosError, AxiosResponse } from 'axios';
import { DapSpreadsheetFactory } from '@/modules/dap/services/dap-spreadsheet.factory';
import { DapSpreadsheetType } from '@/modules/dap/enums';
import { ApprovalHierarchyType, SalesChannel } from '@/modules/direct-sales/enums';
import DapProjectChangeFlowDate from '@/modules/dap/containers/dap-project-change-flow-date/dap-project-change-flow-date.vue';

@Component({
  subscriptions() {
    return {
      searchValue: this.$watchAsObservable('state.search.value').pipe(
        pluck('newValue'),
        debounceTime(400),
        distinctUntilChanged(),
        startWith('')
      )
    };
  },
  components: {
    ActionBar,
    PageLoader,
    ProjectLoader,
    DapProjectChangeFlowDate
  }
})
export default class DapSubmittedProjects extends Vue {
  @Getter(AUTH_GET_USERNAME)
  public userName: string;

  @Getter(AUTH_GET_TOKEN)
  public userToken: string;

  @Getter(GET_LOADING)
  isLoading: boolean;

  public sendForChangeFlowDate: boolean = false;
  public searchValue: string;
  public searchValue$: string;
  public projectTypeDataSource: any[] = ['Estratégia Local'];
  public searchInput: string = '';
  public activeType: number = 1;
  public Size = Size;
  public parseDateToString = dateService.parseDateToString;

  public state: any = {
    currentPage: 1,
    storeProjects: [],
    aovs: [],
    dealers: [],
    regions: [],
    idProject: '',
    projectsSubmeted: [],
    search: {
      properties: [],
      property: 'name',
      value: ''
    },
    userAssociation: {},
    finishedProjectFlow: false
  };

  public channelNames: any = {
    Fleet: 'FROTISTA',
    RentalAgency: 'LOCADORA',
    DisabledPerson: 'PCD',
    TaxiDriver: 'TAXISTA',
    RuralProducer: 'P. RURAL',
    Government: 'GOVERNO',
    AutoEscola: 'AUTO ESCOLA',
    Others: 'OUTROS'
  };

  public dataGeneratePDF: any = {
    idProject: null,
    cdAOV: null,
    cdRegiao: null,
    cdDealer: null
  };

  public moment = moment;

  public get projects() {
    const perPage = 25;
    const projects = _(this.state.projects)
      .filter((project: any) => {
        // const property: string = this.state.search.property;
        return _.size(this.searchValue)
          ? normalize(project.dealerName).includes(normalize(this.searchValue)) ||
              normalize(project.name).includes(normalize(this.searchValue))
          : true;
      })
      .chunk(perPage)
      .value();

    const totalPages = projects.length;
    const page = this.state.currentPage > totalPages ? 1 : this.state.currentPage;
    const pages = [page];
    const pagesTotal = totalPages < 5 ? totalPages : 5;

    if (totalPages > 1) {
      let isLeft = true;
      while (pages.length < pagesTotal) {
        if (isLeft && pages[0] > 1) {
          pages.splice(0, 0, pages[0] - 1);
        } else if (pages[pages.length - 1] < totalPages) {
          pages.push(pages[pages.length - 1] + 1);
        }
        isLeft = !isLeft;
      }
    }

    return {
      page: page,
      perPage: perPage,
      offset: (page - 1) * perPage,
      total: this.state.projects ? this.state.projects.length : 0,
      totalPages,
      pages,
      data: projects[this.state.currentPage - 1] || []
    };
  }

  public get projectsView() {
    return _(this.state.projectsSubmeted)
      .filter((p: IProject) => p.idProjectType === this.activeType)
      .filter((p: IProject) =>
        _.size(this.searchInput)
          ? stringService.normalize(p.name).includes(stringService.normalize(this.searchInput))
          : true
      )
      .orderBy((p: IProject) => -p.id)
      .value();
  }

  public get projectsLojas() {
    const perPage = 13;
    const projects = _(this.state.storeProjects)
      .filter((project: any) => {
        return _.size(this.searchValue)
          ? normalize(project.aov).includes(normalize(this.searchValue)) ||
              normalize(project.region).includes(normalize(this.searchValue)) ||
              normalize(project.dealerName).includes(normalize(this.searchValue)) ||
              normalize(project.dealerNumber).includes(normalize(this.searchValue)) ||
              normalize(project.city).includes(normalize(this.searchValue)) ||
              normalize(project.area).includes(normalize(this.searchValue)) ||
              normalize(project.state).includes(normalize(this.searchValue))
          : true;
      })
      .chunk(perPage)
      .value();

    const totalPages = projects.length;
    const page = this.state.currentPage > totalPages ? 1 : this.state.currentPage;
    const pages = [page];
    const pagesTotal = totalPages < 5 ? totalPages : 5;

    if (totalPages > 1) {
      let isLeft = true;
      while (pages.length < pagesTotal) {
        if (isLeft && pages[0] > 1) {
          pages.splice(0, 0, pages[0] - 1);
        } else if (pages[pages.length - 1] < totalPages) {
          pages.push(pages[pages.length - 1] + 1);
        }
        isLeft = !isLeft;
      }
    }

    return {
      page: page,
      perPage: perPage,
      offset: (page - 1) * perPage,
      total: this.state.storeProjects ? this.state.storeProjects.length : 0,
      totalPages,
      pages,
      data: projects[this.state.currentPage - 1]
    };
  }

  public goBack() {
    this.$router.push({
      name: 'home'
    });
  }

  public goToProject(project: any) {
    this.$router.push({
      name: DAP_ROUTES.SUBMITTED_PROJECT,
      params: {
        projectId: String(project.id),
        storeId: String(project.dealerNumber)
      }
    });
  }

  public goToReportByFamily(project: any) {
    window.open(
      `/neodash/report/${'direct-sales-performance-by-family'}/printing?dialog=1&reports=${JSON.stringify([
        'direct-sales-performance-by-family'
      ])}&filters=${JSON.stringify({
        projectId: String(project.id),
        storeId: String(project.dealerNumber)
      })}&user=${this.userName}&apikey=${this.userToken}`
    );
  }

  public goToReportByChannel(project: any) {
    window.open(
      `/neodash/report/${'direct-sales-performance-by-channel'}/printing?dialog=1&reports=${JSON.stringify([
        'direct-sales-performance-by-channel'
      ])}&filters=${JSON.stringify({
        projectId: project.id.toString(),
        storeId: String(project.dealerNumber)
      })}&user=${this.userName}&apikey=${this.userToken}`
    );
  }

  public saveAsExcel() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/dap/approval/${this.state.idProject}/approvalFlowValuesConfig`)
      .then((res: AxiosResponse) => {
        let unbundled: any[] = _(res.data)
          .map((d: any) =>
            _(d.forecast_RapFamilyResultsPerMonth)
              .map((r: any) => ({
                consolidate: _(d.consolidate_RapFamilyResultsPerMonth)
                  .groupBy(function(d) {
                    return d.year;
                  })
                  .map((c: any) => ({
                    value: _(c)
                      .filter(
                        (f: any) =>
                          f.saleChannel.idSaleChannelAggregate === r.saleChannel.idSaleChannelAggregate &&
                          f.idFamily === r.idFamily
                      )
                      .map((m: any) => m.value)
                      .sum(),
                    description:
                      moment()
                        .startOf('year')
                        .add(
                          _(c)
                            .filter(
                              (f: any) => f.saleChannel.idSaleChannelAggregate === r.saleChannel.idSaleChannelAggregate
                            )
                            .minBy((m: any) => m.month).month - 1,
                          'months'
                        )
                        .format('MMM')
                        .toUpperCase() +
                      '-' +
                      moment()
                        .startOf('year')
                        .add(
                          _(c)
                            .filter(
                              (f: any) => f.saleChannel.idSaleChannelAggregate === r.saleChannel.idSaleChannelAggregate
                            )
                            .maxBy((m: any) => m.month).month - 1,
                          'months'
                        )
                        .format('MMM')
                        .toUpperCase() +
                      '\'' +
                      c[0].year.toString().slice(2, 4)
                  }))
                  .value(),
                value: r.value,
                month: r.month,
                idFamily: r.idFamily,
                monthName: r.monthName,
                familyName: r.familyName,
                year: r.year,
                idSaleChannelAggregate: r.saleChannel.idSaleChannelAggregate,
                idSaleChannelClient: r.saleChannel.idSaleChannelClient,
                nameChannel: r.saleChannel.name,
                nameAggregate: this.channelNames[SalesChannel[r.saleChannel.idSaleChannelAggregate]],
                aov: d.aov,
                approvalHierarchy: d.approvalHierarchy ? d.approvalHierarchy : 0,
                approvalHierarchyName: d.approvalHierarchyName ? d.approvalHierarchyName : 'TDB',
                dealerCompleted: d.dealerCompleted,
                city: d.city,
                dateOpening: d.dateOpening,
                dealerName: d.dealerName,
                dealerNumber: d.dealerNumber,
                groupName: d.groupName,
                idAov: d.idAov,
                idDealer: d.idDealer,
                markedAreaName: d.markedAreaName,
                permitAlter: d.permitAlter,
                region: d.region,
                regionale: d.regionale,
                state: d.state,
                idEntity: r.idEntity
              }))
              .value()
          )
          .flattenDeep()
          .value();

        let grouped: any[] = _(unbundled)
          .groupBy(function(d) {
            return d.dealerNumber + '-' + d.idSaleChannelAggregate + '-' + d.idFamily;
          })
          .map((d: any) => ({
            keyValue: d[0].dealerNumber + '-' + d[0].idSaleChannelAggregate + '-' + d[0].idFamily,
            dealerNumber: d[0].dealerNumber,
            dealerName: d[0].dealerName,
            idSaleChannelAggregate: d[0].idSaleChannelAggregate,
            nameAggregate: d[0].nameAggregate,
            idFamily: d[0].idFamily,
            familyName: d[0].familyName,
            idSaleChannelClient: d[0].idSaleChannelClient,
            nameChannel: d[0].nameChannel,
            aov: d[0].aov,
            city: d[0].city,
            dateOpening: d[0].dateOpening,
            groupName: d[0].groupName,
            idAov: d[0].idAov,
            idDealer: d[0].idDealer,
            markedAreaName: d[0].markedAreaName,
            region: d[0].region,
            regionale: d[0].regionale,
            state: d[0].state,
            consolidate: d[0].consolidate,
            dealerCompleted: d.some(function(f) {
              return f.dealerCompleted == true;
            })
              ? 'Sim'
              : 'Não',
            forecast_RapFamilyResultsPerMonth: _(d)
              .groupBy(function(d) {
                return d.year + '-' + d.month + '-' + d.approvalHierarchy;
              })
              .map((m: any) => ({
                value: _(m)
                  .map((s: any) => s.value)
                  .sum(),
                month: m[0].month,
                monthName: m[0].monthName,
                year: m[0].year,
                approvalHierarchy: m[0].approvalHierarchy,
                approvalHierarchyName: m[0].approvalHierarchyName
              }))
              .orderBy((m: any) => m.month)
              .orderBy((m: any) => m.year)
              .orderBy((m: any) => m.approvalHierarchy)
              .value()
          }))
          .orderBy((m: any) => m.familyName)
          .orderBy((m: any) => m.dealerNumber)
          .value();

        console.log(res.data);
        const spreadSheetAprovationFlow = DapSpreadsheetFactory.get(DapSpreadsheetType.AprovationFlow, grouped)
          .create()
          .saveAsExcel();
      })
      .catch((err: AxiosError) => {
        console.log('Error', err);
      });
  }

  public mounted() {
    this.getProjects();
  }

  @Http('get', `${CONFIG.URL.NEODASH_API}/api/dap/approval/submited/active/1`)
  @Http('get', `${CONFIG.URL.NEODASH_API}/api/dap/approval/user/association/`)
  public getProjects(params?: any, error?, data?) {
    this.state.projectsSubmeted = data[0];
    this.state.userAssociation = data[1];
  }

  public selectProject(projectId: number) {
    this.state.idProject = projectId;
    this.state.storeProjects = _(this.state.projectsSubmeted.filter((p: any) => p.id === this.state.idProject))
      .map((d: any) =>
        _.map(d.storeProjects, (store: any) => ({
          id: d.id,
          name: d.name,
          dealerName: store.name,
          dealerNumber: store.dealerNumber,
          confirmed: store.confirmed,
          state: store.state,
          city: store.city,
          dateForResponseStart: new Date(d.dateForResponseStart),
          dateForResponseEnd: new Date(d.dateForResponseEnd),
          region: store.region,
          aov: store.aov,
          area: store.area,
          idAOV: store.idAov,
          idRegiao: store.idLocaleAgg
        }))
      )
      .flatten()
      .orderBy((d: any) => d.dealerName)
      .orderBy((d: any) => -d.id)
      .value();

    this.dataGeneratePDF = {
      idProject: null,
      cdAOV: null,
      cdRegiao: null,
      cdDealer: null,
      reportType: null,
      typeExtensionReport: null
    };

    this.dataGeneratePDF.idProject = projectId;

    this.state.aovs = _(this.state.storeProjects)
      .map((store: any) => ({
        text: store.aov,
        value: store.idAOV
      }))
      .uniqBy((d: any) => d.value)
      .value();
  }

  public reloadProjects(object: any) {
    this.getProjects();
    this.sendForChangeFlowDate = false;
  }

  public goToChangeFlowDate(projectId: number, projectName: string) {
    this.state.idProject = projectId;
    this.state.projectName = projectName;
    this.sendForChangeFlowDate = true;
  }
}
